<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {

	computed: {
		...mapGetters({
			token: 'getToken'
		})
	}
}
</script>

<style lang="scss" scoped>
#app {
	height: 100%;
	width: 100%;
}
</style>
